/**
 * LoginSuccess
 * OAuth callback landing page. Parses URL parameters returned by the auth
 * provider, persists tokens to localStorage, fetches the current user profile,
 * and initializes the local app session before navigating to the main app.
 *
 * Responsibilities:
 * - Read OAuth query params (`access_token`, `refresh_token`, etc.)
 * - Persist minimal session tokens to `localStorage`
 * - Call `/me/` to obtain user profile, organization and perform app login
 * - Redirect the user to the default post-login route
 */
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { apiCall } from "../../utils/server_utils";
import { API_SUCCESS_RESPONSE_CODE,PRODUCT_NAME} from "../../utils/config_mapping";
import login_bg from "../../assets/images/login_bg.svg"; // Adjust the path
import { AuthData } from "../../auth/AuthWrapper";
import { useNavigate } from "react-router-dom";
import { fetchAndStorePageAccess } from "../../utils/page_access";



export const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const { login } = AuthData();
  const navigate = useNavigate();

  const success = searchParams.get('success');
  const data = searchParams.get('data');
  const error = searchParams.get('error');
  const code = searchParams.get('code');
  const accessToken = searchParams.get('access_token');
  const refreshToken = searchParams.get('refresh_token');

  const jsonObject = {
    success: success,
    data: data,
    error: error,
    code: code,
    accessToken: accessToken,
    refreshToken: refreshToken
  };

  if (accessToken !== "" && accessToken !== "") {
    localStorage.setItem("jsondata", JSON.stringify(jsonObject));
  }

  const handleLogin = useCallback((name) => {
    login(name, 'password');
  }, [login]);

  const handleNavigate = useCallback(() => {
    navigate("/document-list");
  }, [navigate]);

  useEffect(() => {
    fetchAndStorePageAccess();
    const fetchData = async () => {
      try {
        const result = await apiCall("GET", `${API_SERVER_URL}me/`);
        if (result !== undefined && result.code === API_SUCCESS_RESPONSE_CODE) {
          localStorage.setItem("organization", result.data.data.organization);
          await handleLogin(result.data.data.full_name);
          handleNavigate();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [handleLogin, handleNavigate]);

  return (
    <div className="min-h-screen flex w-full bg-slate-50">
      <div className="min-h-screen w-screen flex items-center justify-center bg-background p-4">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl flex items-center justify-center shadow-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text w-6 h-6 text-white"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
              </div>
              <h1 className="text-2xl font-bold text-foreground">ContractGenie<sup>TM</sup></h1>
            </div>
            <div className="space-y-2">
              {/* <h2 className="text-xl font-semibold text-foreground">Login Successful</h2> */}
              {/* <p className="text-muted-foreground">You are being redirected to your dashboard...</p> */}
            </div>
          </div>
          <div className="rounded-lg border bg-card text-card-foreground shadow-lg">
            <div className="flex flex-col p-6 space-y-1 text-center">
              <h3 className="font-semibold tracking-tight text-lg">Welcome to ContractGenie<sup>TM</sup></h3>
              {/* <p className="text-sm text-muted-foreground">Initializing your session and loading your data</p> */}
                          <p className="text-muted-foreground">You are being redirected to your dashboard...</p>
            </div>
            <div className="p-6 pt-0 space-y-6 flex flex-col items-center">
              <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
              {/* <div className="text-center">
                <p className="text-sm text-muted-foreground">If you are not redirected automatically, <span className="underline cursor-pointer hover:text-foreground" onClick={handleNavigate}>click here</span>.</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
